import React from 'react';
import {
  FormControl,
  TableContainer,
  Table,
  TableCell,
  TableHead,
  Grid,
  TableRow,
  TableBody
} from '@mui/material';
import { Colors } from '../utils/Colors';
import { ErpTrialRow } from './ErpTrialRow';
import { HomeworkTrial } from '../utils/Homework';

const formStyle = {
  backgroundColor: Colors.lightGray,
  border: `4px solid ${Colors.skobeloff}`,
  borderRadius: '15px',
  padding: '10px 5px'
};

function EntryTable({
  data,
  onTrialChange,
  onTrialUpdate
}: {
  data: HomeworkTrial[];
  onTrialChange: (event: any, trialId: string) => void;
  onTrialUpdate: (trialId: string) => void;
}) {
  return (
    <Grid item xs={12} md={12} lg={12} xl={6} style={formStyle}>
      <Grid container spacing={2} style={{ padding: '20px' }}>
        <FormControl style={{ width: '100%' }}>
          <TableContainer>
            <Table aria-label="erp trial">
              <TableHead>
                <TableRow>
                  <TableCell>Trial</TableCell>
                  <TableCell>Goal (sec)</TableCell>
                  <TableCell>Completed (sec)</TableCell>
                  {/* <TableCell padding="checkbox">Status</TableCell> */}
                  <TableCell>Starting Anxiety</TableCell>
                  <TableCell>Ending Anxiety</TableCell>
                  <TableCell>Notes</TableCell>
                  <TableCell> </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  ?.sort((a, b) => a.order - b.order)
                  .map((row: HomeworkTrial, idx: number) => (
                    <ErpTrialRow
                      onChange={onTrialChange}
                      onTrialUpdate={onTrialUpdate}
                      key={row.id}
                      trial={row}
                      idx={idx}
                    />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export function ErpTrial({
  trials,
  onTrialChange,
  onTrialUpdate,
  overrideStyles
}: {
  trials: HomeworkTrial[];
  onTrialChange: (event: any, trialId: string) => void;
  onTrialUpdate: (trialId: string) => void;
  overrideStyles?: any;
}) {
  return (
    <Grid container style={overrideStyles}>
      <EntryTable
        onTrialChange={onTrialChange}
        onTrialUpdate={onTrialUpdate}
        data={trials}
      />
    </Grid>
  );
}
